import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["radio"];

  connect() {
    this.radioTargets.forEach(radio => {
      radio.addEventListener("change", this.syncRadios);
    });
  }

  syncRadios = (event) => {
    const selectedValue = event.target.value;

    const allRadios = document.querySelectorAll(`input[name='maximum']`);
    allRadios.forEach(r => {
      r.checked = r.value === selectedValue;
    });
  }
}
